import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { Country } from "@myProfile/models";

/**
 * Fetches countries for dropdown
 * API: GET /entitlements/v1/user/Common/GetAllCountry
 *
 * Response: Array of { id: number, countryName: string }
 * Normalized to: Array of { id: string, name: string }
 */
export const fetchCountriesThunk = createAsyncThunk<Country[], void, ThunkApiConfig>(
  "myProfile/fetchCountries",
  async (_, { extra, rejectWithValue }) => {
    try {
      const url = "/entitlements/v1/user/Common/GetAllCountry";
      const response = await extra<Array<{ id: number; countryName: string }>>(url, {
        method: "GET",
      });

      // Ensure the response data is an array and normalize the data structure
      const rawData = Array.isArray(response.data) ? response.data : [];

      const countries = rawData
        .filter((country: any) => country && country.id && country.countryName)
        .map((country: any) => ({
          id: String(country.id),
          name: country.countryName,
        }));

      return countries;
    } catch (error: any) {
      console.error("[Countries API] Error fetching data:", error);

      return rejectWithValue("Failed to load countries");
    }
  }
);
